module.exports = __webpack_public_path__ + "img/tshirt.4c5baa50.png";